var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExPickerPopUp',{ref:"pickerPopup",attrs:{"value":_vm.dialog,"htmlInfo":_vm.info,"icon":"currency_icon","applyBorderClass":true,"dropdownCurrencyList":_vm.dropdownCurrencyList},on:{"input":function($event){return _vm.$emit('onClose')},"onAction":_vm.handleAddCurrency}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }